import Vue from 'vue'
import Toast from 'vue-toastification'

// Toast Notification Component Styles
import '@core/scss/vue/libs/toastification.scss'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ButtonContent from './toastOnClick.vue'
/**
 * NOTE: If you are using other transition them make sure to import it in `src/@core/scss/vue/libs/notification.scss` from it's source
 */
Vue.use(Toast, {
  hideProgressBar: true,
  closeOnClick: false,
  closeButton: false,
  icon: false,
  timeout: 3000,
  transition: 'Vue-Toastification__fade',
})
const notif = (title, text, variant, icon = 'InfoIcon', timeout = 1500) => {
  Vue.$toast({
    component: ToastificationContent,
    props: {
      title,
      icon,
      text,
      variant
    },
  },
  {
    timeout,
    position: 'top-right'
  })
} 
Vue.prototype.$notif = notif

const notifOnClick = (title, text, variant, icon = 'InfoIcon', buttonVariant, buttonText, callback, onCloseClickCallback = () => {}) => {
  Vue.$toast({
    component: ToastificationContent,
    props: {
      title,
      icon,
      text,
      variant,
      button: true,
      buttonText,
      buttonVariant,
      buttonOnClick: callback,
      onCloseClick: onCloseClickCallback
    }
  },
  {
    timeout: false,
    position: 'top-right',
  })
} 

Vue.prototype.$notifOnClick = notifOnClick

export default { notifOnClick, notif }